import * as React from 'react'
import { useTranslation } from 'react-i18next'
import Popover from '../Popover/Popover'
import styled, { css } from 'styled-components'
import Icon, { IconTypes } from '../Icons/Icon'
import { Style } from '../../styles'
import InboxFilterItem from './InboxFilterItem'
import { ConversationState } from '../../types'

const Container = styled.div`
  background: white;
  min-width: 200px;
  box-shadow: 0 8px 16px -4px rgba(9,30,66,.25), 0 0 0 1px rgba(9,30,66,.08);
  border-radius: 3px;
  margin: 4px 0;
`

interface IProps {
  activator: JSX.Element
  status?: ConversationState
  onSubmit: (status?: ConversationState) => void
}

const ConversationStatusPopover = (props: IProps) => {
  const { t } = useTranslation()
  const { activator, status } = props

  const [popoverActive, setPopoverActive] = React.useState(false)

  const onTogglePopover = () => {
    setPopoverActive(!popoverActive)
  }

  const onPopoverClose = () => {
    setPopoverActive(false)
  }

  const onStatusChange = (status: ConversationState) => {
    props.onSubmit(status)
    onPopoverClose()
  }

  const items: {
    icon: IconTypes
    label: string
    status: ConversationState
  }[] = [
      { icon: 'archive-arrow-up', label: t(`ConversationState::${ConversationState.OPEN}`), status: ConversationState.OPEN },
      { icon: 'archive-arrow-down', label: t(`ConversationState::${ConversationState.CLOSED}`), status: ConversationState.CLOSED },
      { icon: 'snooze', label: t(`ConversationState::${ConversationState.SNOOZED}`), status: ConversationState.SNOOZED },
    ]

  return (
    <Popover
      active={popoverActive}
      activator={
        <div onClick={onTogglePopover}>
          {activator}
        </div>
      }
      onClose={onPopoverClose}
      placement='bottom-start'
    >
      <Container>
        {items.map(item => (
          <InboxFilterItem key={item.status} onClick={() => onStatusChange(item.status)} active={item.status === status}>
            <Icon icon={item.icon} />
            {item.label}
          </InboxFilterItem>
        ))}
      </Container>
    </Popover>
  )
}

export default ConversationStatusPopover